export default __webpack_public_path__ + "static/media/iconesFornecedores.7c96a332.png";